module.exports = function getCountries() {
	const countries = require("./countries.json");
	return countries;
};
